export default __webpack_public_path__ + "static/media/storyfm.ef0cf662.png";